module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "download"
    }
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e653b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProfitShareSetting/comm/excel.vue
// module id = 1084
// module chunks = 1